import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { queryClient } from "@/shared/lib/react-query";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useRejectSignEntry } from "../mutate-hooks/use-reject-sign-entry";

export const useRejectSignEntryModal = (
  sectionOneId: string,
  search?: string,
) => {
  const { mutate: rejectEntry } = useRejectSignEntry(sectionOneId, search);

  const handleReject = ({
    sectionOneListId,
    itemNoVersionId,
    signerEmployeeId,
    comment,
  }: {
    sectionOneListId: string;
    itemNoVersionId: string;
    signerEmployeeId: string;
    comment: string;
  }) => {
    rejectEntry(
      {
        params: {
          path: {
            sectionOneListId,
            itemNoVersionId,
          },
        },
        body: {
          signer: {
            signerEmployeeId,
          },
          comment,
        },
      },
      {
        onSuccess: () => {
          notification.success({ message: NOTIFICATION_MESSAGES.ENTRY_RECALLED_SUCCESS }); // "Запись отозвана"
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getSection1({
              sectionOneId,
              search,
            }).queryKey,
          });
        },
        onError: () => {
          notification.error({ message: NOTIFICATION_MESSAGES.ENTRY_REJECT_ERROR }); // "Ошибка при отклонении"
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getSection1({
              sectionOneId,
              search,
            }).queryKey,
          });
        },
        onSettled: () => {
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getSection1({
              sectionOneId,
              search,
            }).queryKey,
          });
          // Инвалидируем таблицу подписантов
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getSectionOneSignersList(sectionOneId).queryKey,
          });
        },
      },
    );
  };

  return { handleReject };
};
